import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { ScrollyArticle } from '../components/ScrollyPage/ScrollyArticle';

const StoryKonInkomst = lazy(
    () => import('../components/ScrollyPage/StoryKonInkomst')
);

export const Route = createFileRoute('/om/kon-inkomst')({
    component: Index,
});

function Index() {
    return (
        <ScrollyArticle>
            <Suspense fallback={null}>
                <StoryKonInkomst />
            </Suspense>
        </ScrollyArticle>
    );
}
